import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { LegacyTokens } from "../../../../theme/b13Tokens";
import { resolvePhaseIcon } from "../../../../Components/IconPicker/IconPicker";

// Batch 7 §7.2 — read-only single-row phase strip under the OBJECTIVE:
// subheader. Name + colour only. No criteria text (that heaviness is
// what made the current version noisy). Non-interactive; it is
// orientation, not navigation.

export type FlowStripPhase = {
  phaseName: string;
  colour?: string | null;
  icon?: string | null;
};

export default function WorkflowFlowStrip({ phases }: { phases: FlowStripPhase[] }) {
  const visible = phases.filter((p) => p.phaseName.trim());
  if (visible.length === 0) return null;

  return (
    <Box
      role="figure"
      aria-label="Workflow phase sequence"
      sx={{ mb: 3, display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1 }}
    >
      {visible.map((p, i) => {
        const colour = p.colour || LegacyTokens.blue;
        const Ic = resolvePhaseIcon(p.icon);
        return (
          <Stack key={i} direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                display: "inline-flex", alignItems: "center", gap: 0.5,
                px: 1, py: 0.25,
                borderRadius: `${LegacyTokens.radius.chip}px`,
                backgroundColor: colour,
                color: LegacyTokens.surface,
              }}
            >
              <Ic sx={{ fontSize: 14 }} />
              <Typography sx={{ fontSize: 12, fontWeight: 600, letterSpacing: 0.2 }}>
                {p.phaseName}
              </Typography>
            </Box>
            {i < visible.length - 1 && (
              <ArrowForwardIcon sx={{ fontSize: 14, color: LegacyTokens.ink3 }} />
            )}
          </Stack>
        );
      })}
    </Box>
  );
}
